import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function Trash(): React.ReactElement {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#icon_trash)">
        <path
          d="M2.53598 13.5979C2.53598 14.6296 3.37532 15.4694 4.40749 15.4694H11.8936C12.9258 15.4694 13.7651 14.6296 13.7651 13.5979V4.24026H2.53598V13.5979Z"
        />
        <path
          d="M10.0236 1.43272V0.496964H6.28053V1.43272H1.60172V3.30423H14.7024V1.43272H10.0236Z"
        />
      </g>
      <defs>
        <clipPath id="icon_trash">
          <rect
            width="14.9722"
            height="14.9722"
            transform="translate(0.664215 0.496964)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
